module.exports = __webpack_public_path__ + "img/yilianGl13.913b22b4.png";